import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Invite } from '../../../core/models/invite';
import { UserDao } from '../../../core/services/dao/userDao';
import { AuthService } from '../../../core/services/auth.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { MatStepper } from '@angular/material/stepper';
import { PaymentDao } from '../../../core/services/dao/paymentDao';

@Component({
  selector: 'app-create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.scss'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false }
    }
  ]
})
export class CreateAccountComponent implements OnInit, OnDestroy {
  @ViewChild('stepper') stepper: MatStepper;

  public invite: Invite;

  //whats being passed from account step to brands step
  public data;
  //whats being passed from brands to payment step
  public paymentData;
  // //whats being passed from payment to parent
  // public cardData;

  public brands;
  //array of objects representing
  //brands with card information
  //and expanded states
  //example: {
  // name:'exampleBrand'*brand name
  // card: brand of Card(visa) + ' ******' + last four digits of card,
  // expanded:false *default should be false
  //interval: billing interval(year/month)
  // }
  public brandsForDisplay = [];

  public cardInfoData;
  public cards = [];
  private subs = [];
  public subIds;

  public paymentOptions = false;
  public isBilled = false;

  public user;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userDao: UserDao,
    private authService: AuthService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private paymentDao: PaymentDao
  ) {
    this.matIconRegistry.addSvgIcon(
      `advocado_inline_full_color`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/image/Advocado_Logomark_Full-Color.svg`)
    );

    this.matIconRegistry.addSvgIcon(
      `advocado_inline_black`,
      this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/image/Advocado_Logomark_Black.svg`)
    );
  }

  ngOnInit() {
    if (this.route.snapshot.data.invite) {
      this.invite = this.route.snapshot.data.invite as Invite;
    }
  }

  /**
   * When account step is completed, isBilled configures
   * the rest of the flow to either bail out after brands step
   * or continue to completion.
   * @param data: if not billed =
   *         const data = {
   *             password: this.userForm.get('password').value,
   *             isBilled: this.isBilled,
   *             user: user
   *           }
   *           if billed =
   *              const data = {
   *                     isBilled: true,
   *                     user: this.user
   *                   };
   *
   */
  onAccountCreated(data: any) {
    this.data = data;
    this.user = data.user;
    this.move(1);
  }

  /**
   * When brand step is completed, step to payment step
   */
  continueToPayment(data: any) {
    this.paymentData = data;
    this.subIds = data.subIds;
    this.stepper.next();
    this.move(2);
  }

  consumeBrands(brands) {
    this.brands = brands;
  }

  /**
   *
   * When payment step is completed, check if multiple brands
   * if multiple brands active payment options page
   * we also have to populate a brands for display array
   * to handle expanded states and tie card display
   */
  onCardCreated(data: any) {
    this.cardInfoData = data.card;
    if (this.brands.length > 1) {
      this.paymentOptions = true;
    } else {
      this.brands[0].card = data.card;
      this.brandsForDisplay.push(this.brands[0]);
    }
    this.move(3);
  }

  ingestCards(data: any) {
    this.cards = data;
  }

  ingestBrandsToDisplay(data: any) {
    this.brandsForDisplay = data;
  }

  checkIngest(data: any) {
    if (this.cards.length !== 0 && this.brandsForDisplay.length !== 0) {
      this.paymentOptions = false;
    }
  }

  /**
   * We have to charge the payment intent before updating the subscription interval
   */
  async chargeBrands() {
    for (const data of this.paymentData.paymentIntents) {
     // await this.paymentDao.charge(data.pi, data.id).subscribe(() => {});
    }
  }

  intervalCheck() {
    this.brands.forEach((br) => {
      if (br.interval !== 'month') {
        this.subIds.forEach((subId) => {
          if (subId.id === br.id) {
          //  this.paymentDao.updateSubscriptionInterval(br, subId.subId).subscribe(() => {});
          }
        });
      }
    });
    return;
  }

  async goToHome() {
    await this.chargeBrands().then(() => {
      this.intervalCheck();
      this.authService.login(this.user.email, this.data.password).subscribe(() => {
        this.router.navigate(['/manage/ad-codes']).catch((err) => {
          console.error(err);
        });
      });
    });
  }

  move(index: number) {
    // update current step
    this.stepper.selected.editable = false;
    this.stepper.selected.completed = true;
    // move to next step
    this.stepper.selectedIndex = index;
    this.stepper.selected.editable = true;
    this.stepper.selected.completed = false;
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }
}
